import * as client_hooks from '../../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52')
];

export const server_loads = [0,2,4,6,8,9,10,11,12,3];

export const dictionary = {
		"/(pages)/[[lang=lang]]/alle-avtaler": [~19,[2]],
		"/(pages)/[[lang=lang]]/design": [20,[2]],
		"/(pages)/[[lang=lang]]/design/knapper": [21,[2]],
		"/(pages)/[[lang=lang]]/gammel/spotprisen": [22,[2,4]],
		"/(pages)/[[lang=lang]]/gammel/spotprisen/tabell": [23,[2,4]],
		"/(pages)/[[lang=lang]]/gammel/spotprisen/timespris/[[area]]": [24,[2,4,5]],
		"/(pages)/[[lang=lang]]/(redirect)/hoiax": [~14,[2]],
		"/(pages)/[[lang=lang]]/kundeservice/ring-meg": [25,[2]],
		"/(pages)/landingsside/[id]": [~52,[2]],
		"/(pages)/[[lang=lang]]/nettbutikk": [~26,[2,6]],
		"/(pages)/[[lang=lang]]/nettbutikk/kategori/[category]": [~29,[2,6]],
		"/(pages)/[[lang=lang]]/nettbutikk/kategori/[category]/kjopsbetingelser": [~30,[2,6]],
		"/(pages)/[[lang=lang]]/nettbutikk/kategori/[category]/standard-installasjon": [~31,[2,6]],
		"/(pages)/[[lang=lang]]/nettbutikk/[product]": [~27,[2]],
		"/(pages)/[[lang=lang]]/nettbutikk/[product]/bestill": [~28,[2]],
		"/(pages)/[[lang=lang]]/norgespris": [~32,[2]],
		"/(pages)/[[lang=lang]]/om/aktuelt/(lists)": [~33,[2,7]],
		"/(pages)/[[lang=lang]]/om/aktuelt/(lists)/sparetips": [~34,[2,7]],
		"/(pages)/[[lang=lang]]/om/aktuelt/[slug]": [35,[2,8]],
		"/(pages)/[[lang=lang]]/om/personvern": [~36,[2]],
		"/(pages)/[[lang=lang]]/om/personvern/cookies": [37,[2]],
		"/(pages)/[[lang=lang]]/(redirect)/pensjonistforbundet": [~16,[2]],
		"/(pages)/[[lang=lang]]/(redirect)/pensjonist": [~15,[2]],
		"/(pages)/[[lang=lang]]/privat/avtalevilkar-for-levering-av-kraft": [~38,[2]],
		"/(pages)/[[lang=lang]]/privat/hva-koster": [39,[2,9]],
		"/(pages)/[[lang=lang]]/privat/kundeservice": [~40,[2]],
		"/(pages)/[[lang=lang]]/privat/samarbeidspartnere": [~41,[2]],
		"/(pages)/[[lang=lang]]/privat/skjema": [~42,[2]],
		"/(pages)/[[lang=lang]]/privat/skjema/move-to-new-address": [43,[2]],
		"/(pages)/[[lang=lang]]/privat/smartlading": [~44,[2]],
		"/(pages)/[[lang=lang]]/privat/stromanalyse": [~45,[2]],
		"/(pages)/[[lang=lang]]/(redirect)/senior": [~17,[2]],
		"/(pages)/[[lang=lang]]/sok": [46,[2]],
		"/(pages)/[[lang=lang]]/sporsmal-svar/[...slug]": [~47,[2]],
		"/(pages)/[[lang=lang]]/spotprisen/historikk/[...path=historikkPath]": [~49,[2,10]],
		"/(pages)/[[lang=lang]]/spotprisen/[...path=spotprisenPath]": [48,[2,10,11]],
		"/(pages)/[[lang=lang]]/stromavtale": [~50,[2]],
		"/(pages)/[[lang=lang]]/stromavtale/[slug]/[[omraade=avtaleOmraade]]/[[bindingstid=fastprisBinding]]": [~51,[2,12]],
		"/(pages)/[[lang=lang]]": [~13,[2]],
		"/(pages)/[[lang=lang]]/[slug]": [~18,[2,3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);